import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { IntercomService } from '@core/providers';

import { ErrorStateCardComponent } from '../../components/error-state-card/error-state-card.component';

@Component({
  selector: 'la-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ErrorStateCardComponent],
})
export class PageNotFoundComponent implements OnInit, OnDestroy {
  private intercom = inject(IntercomService);
  private router = inject(Router);

  private t?: ReturnType<typeof setTimeout>;
  protected readonly title = 'Page not found';
  protected readonly body = "Let's get you back on the map.";

  public ngOnInit() {
    this.t = setTimeout(() => {
      this.intercom.show();
    }, 10000);
  }

  protected navigateToMaps() {
    this.intercom.hide();
    this.router.navigate(['/maps']);
  }

  public ngOnDestroy() {
    clearTimeout(this.t);
  }
}
